import { Link } from "react-router-dom";

export function ModuleNotFoundPage() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 p-8 text-center">
      <h1 className="text-2xl font-bold text-navy-deep">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you requested does not exist or is not available.
      </p>
      <Link to="/dashboard" className="text-sm font-semibold text-blue-700 hover:underline">
        Back to dashboard
      </Link>
    </div>
  );
}
